/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import {
  IMediaModel,
  MediaType,
  RouteHelper,
  useCanWatchAuthContent,
  useIsPlayableWithDate,
} from "@nf/common";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

import Button, { ButtonSize } from "components/Button";
import { useSyncCompleted } from "hooks";

import PlayIcon from "resources/icons/play.svg";

const OfferButton = dynamic(() => import("components/OfferButton"));

export interface PlayButtonProps {
  media?: IMediaModel;
  size?: ButtonSize;
}

export const PlayButton = ({ media, size }: PlayButtonProps) => {
  const { t } = useTranslation("translations");
  const { canWatch } = useCanWatchAuthContent(media);
  const { isPlayable, availableFrom } = useIsPlayableWithDate(media);
  const isAuthProcessCompleted = useSyncCompleted();

  const isCollection = media?.MediaTypeCode === MediaType.Collection;
  const isComingSoon = !isPlayable && availableFrom;

  if (media && (canWatch || !isAuthProcessCompleted)) {
    return (
      <Button
        href={
          !isAuthProcessCompleted
            ? undefined
            : isCollection
            ? RouteHelper.goToDetails(media)
            : RouteHelper.goToPlayer(media)
        }
        variant={isComingSoon ? "secondary" : "primary"}
        size={size}
        icon={isComingSoon ? null : <PlayIcon />}
        state={
          !isAuthProcessCompleted
            ? "skeleton"
            : isComingSoon
            ? "disabled"
            : undefined
        }
      >
        {isComingSoon
          ? t("web_asset_page_avaliable_from", { date: availableFrom })
          : t("web_highlight_asset_button_watch_now")}
      </Button>
    );
  }

  return <OfferButton size={size} />;
};

export default PlayButton;
